import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded = ["element", "children", "className", "bare", "cta", "color", "skip"];

var Link = function Link(_ref) {
  var element = _ref.element,
      children = _ref.children,
      className = _ref.className,
      bare = _ref.bare,
      cta = _ref.cta,
      color = _ref.color,
      skip = _ref.skip,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var Element = element;
  return /*#__PURE__*/React.createElement(Element, _extends({}, rest, {
    className: classnames('ln-c-link', bare && 'ln-c-link--bare', cta && 'ln-c-link--cta', color && "ln-c-link--" + color, skip && 'ln-c-link--skip', className)
  }), children);
};

Link.propTypes = {
  element: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
  children: PropTypes.node,
  className: PropTypes.string,

  /** Only shows the underline on focus or hover */
  bare: PropTypes.bool,

  /** Applies the button type styling  */
  cta: PropTypes.bool,

  /** Sets the link colour */
  color: PropTypes.string,

  /** Sets skip link behaviour so that it only shows on keyboard focus */
  skip: PropTypes.bool
};
Link.defaultProps = {
  element: 'a',
  children: undefined,
  className: undefined,
  bare: false,
  cta: false,
  color: undefined,
  skip: false
};
Link.displayName = 'Link'; // eslint-disable-next-line import/prefer-default-export

export { Link };